import { Component, TemplateRef, inject } from '@angular/core';

import { ToastService } from './toast.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'toasts-container',
  standalone: true,
  imports: [CommonModule],
  template: `
    @for (toast of toastService.toasts; track toast) {
      <ngb-toast
        [class]="toast.classname"
        [autohide]="true"
        [header]="toast.header"
        [delay]="toast.delay || 5000"
        (hidden)="toastService.remove(toast)"
        >
        @if (isTemplate(toast)) {
          <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
        } @else {
          {{ toast.textOrTpl }}
        }
      </ngb-toast>
    }
    `,
  host: { '[class.ngb-toasts]': 'true' },
})
export class ToastsContainer {
  toastService = inject(ToastService);


  isTemplate(toast) {
    return toast.textOrTpl instanceof TemplateRef;
  }
}
